import api from "./api";

const RESOURCE = "/api/pessoa/pj";

const Peoples = {
  sendData: async (data) => await api.post(RESOURCE, { ...data }),
  editingData: async (id, data) =>
    await api.put(RESOURCE + `/${id}`, { ...data }),
};

export default Peoples;
